import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ModalForm, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "../../hooks/useService";
import useContractPatternForm, { toFieldErrors } from "../../hooks/useContractPatternForm";
import ContractPatternFields from "../ContractPatternFields";

// O erro do campo da lib (o span filho direto do label) fica 20px abaixo dele, em
// posição absoluta: nas colunas estreitas do modal, sem quebra para não cair por cima da
// linha do campo. Absoluto, ele não alarga a coluna.
// O recuo à direita dá lugar ao balão do tooltip da última coluna (256px, centrado no
// ícone), que a lib deixa no layout mesmo escondido e que passaria da borda do modal.
const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 16px;

  label > span {
    white-space: nowrap;
  }
`;

/** "Novo padrão de contrato", aberto do formulário de contrato. Só monta com `show`. */
export default function ContractPatternModal({ show, ...props }) {
  if (!show) return null;
  return <PatternModal {...props} />;
}

function PatternModal({ onHide, onCreated }) {
  const patternService = useService("contractPatterns");
  const [loading, setLoading] = useState(false);
  // Os erros aparecem nos campos depois da primeira tentativa e se atualizam a cada mudança
  const [submitted, setSubmitted] = useState(false);

  const form = useContractPatternForm();
  const fieldErrors = submitted ? toFieldErrors(form.validateAll()) : {};

  function close() {
    if (loading) return;
    onHide();
  }

  async function handleSubmit() {
    setSubmitted(true);
    if (form.validateAll().length) return;

    setLoading(true);
    try {
      const result = await patternService.create(form.toPayload());

      if (result && !result.error) {
        toast.success("Padrão criado com sucesso!");
        const newPattern = result.data?.data || result.data;
        setLoading(false);
        onHide();
        if (onCreated) onCreated(newPattern);
        return;
      }
      throw new Error(result?.msg || "Erro ao criar padrão");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.msg || error?.message || "Erro ao criar padrão");
    }
    setLoading(false);
  }

  return (
    <ModalForm
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $isLoading={loading}
      $size="large"
      $title="Novo padrão de contrato"
      $contentBackground="N0"
      $actions={[
        { text: "Cancelar", action: close, variant: "outline", isDisabled: loading },
        { text: "Criar padrão", action: handleSubmit, variant: "primary", isDisabled: loading },
      ]}
    >
      <Body>
        <Text
          $text="O padrão criado já fica escolhido neste contrato e pode ser usado nos próximos."
          $variant="paragraph_small_medium"
          $color="N700"
        />
        <ContractPatternFields values={form.values} onChange={form.setField} errors={fieldErrors} />
      </Body>
    </ModalForm>
  );
}
